var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-12 col-md-5 mx-auto" }, [
      _c("section", { staticClass: "who-testimonial" }, [
        _c("h1", { staticClass: "who-testimonial-heading" }, [
          _vm._v(_vm._s(_vm._f("trans")("st_public.Testimonial")))
        ]),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12 col-md-6" }, [
            _c("div", { staticClass: "who-testimonial-elm" }, [
              _c("p", [
                _vm._v(
                  "\n              " +
                    _vm._s(_vm._f("trans")("st_public.who_testimonial_1")) +
                    "\n            "
                )
              ]),
              _c("div", { staticClass: "avatar" }, [
                _c("img", {
                  attrs: {
                    width: "40",
                    src: require("assets/img/testimonial-who-1.png")
                  }
                }),
                _c("div", { staticClass: "avatar-info" }, [
                  _c("h6", [
                    _vm._v(
                      _vm._s(
                        _vm._f("trans")("st_public.who_testimonial_name_1")
                      )
                    )
                  ])
                ])
              ])
            ])
          ]),
          _c("div", { staticClass: "col-12 col-md-6" }, [
            _c("div", { staticClass: "who-testimonial-elm" }, [
              _c("p", [
                _vm._v(
                  "\n              " +
                    _vm._s(_vm._f("trans")("st_public.who_testimonial_2")) +
                    "\n            "
                )
              ]),
              _c("div", { staticClass: "avatar" }, [
                _c("img", {
                  attrs: {
                    width: "40",
                    src: require("assets/img/testimonial-who-2.png")
                  }
                }),
                _c("div", { staticClass: "avatar-info" }, [
                  _c("h6", [
                    _vm._v(
                      _vm._s(
                        _vm._f("trans")("st_public.who_testimonial_name_2")
                      )
                    )
                  ])
                ])
              ])
            ])
          ]),
          _c("div", { staticClass: "col-12 col-md-6" }, [
            _c("div", { staticClass: "who-testimonial-elm" }, [
              _c("p", [
                _vm._v(
                  "\n              " +
                    _vm._s(_vm._f("trans")("st_public.who_testimonial_3")) +
                    "\n            "
                )
              ]),
              _c("div", { staticClass: "avatar" }, [
                _c("img", {
                  attrs: {
                    width: "40",
                    src: require("assets/img/testimonial-who-3.png")
                  }
                }),
                _c("div", { staticClass: "avatar-info" }, [
                  _c("h6", [
                    _vm._v(
                      _vm._s(
                        _vm._f("trans")("st_public.who_testimonial_name_3")
                      )
                    )
                  ])
                ])
              ])
            ])
          ]),
          _c("div", { staticClass: "col-12 col-md-6" }, [
            _c("div", { staticClass: "who-testimonial-elm" }, [
              _c("p", [
                _vm._v(
                  "\n              " +
                    _vm._s(_vm._f("trans")("st_public.who_testimonial_4")) +
                    "\n            "
                )
              ]),
              _c("div", { staticClass: "avatar" }, [
                _c("img", {
                  attrs: {
                    width: "40",
                    src: require("assets/img/testimonial-who-4.png")
                  }
                }),
                _c("div", { staticClass: "avatar-info" }, [
                  _c("h6", [
                    _vm._v(
                      _vm._s(
                        _vm._f("trans")("st_public.who_testimonial_name_4")
                      )
                    )
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c71cc0c8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c71cc0c8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/WhoTestimonial.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-c71cc0c8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/WhoTestimonial.vue
// module chunks = 2 3 4 5 6